/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-expressions */
'use client';

import { useEffect, useRef } from 'react';
import Typed from 'typed.js';

interface Props {
    text: string;
    speed?: number;
    showCursor?: boolean;
    onComplete?: () => void;
    onBegin?: () => void;
    onStringTyped?: () => void;
    className?: string;
}

const TypedEffect: React.FC<Props> = ({
    text,
    className,
    onComplete,
    onBegin,
    onStringTyped,
    speed = 30,
    showCursor = true
}) => {
    const el = useRef(null);

    useEffect(() => {
        const typed = new Typed(el.current, {
            strings: [text],
            typeSpeed: speed,
            showCursor: showCursor,
            onBegin: () => {
                onBegin && onBegin();
            },
            onComplete: (self) => {
                if (showCursor) {
                    setTimeout(() => {
                        self?.cursor?.remove();
                    }, 1000);
                }
                onComplete && onComplete();
            },
            onStringTyped: () => {
                onStringTyped && onStringTyped();
            }
        });
        return () => {
            typed.destroy();
        };
    }, []);

    return <span className={className} ref={el} />;
};

export default TypedEffect;

